export class FixedHeader {
    constructor({
        selector = '.fixed-header',
        scrollThreshold = 50,
    } = {}) {
        this.selector = selector;
        this.scrollThreshold = scrollThreshold;
        this.header = document.querySelector(this.selector);
    }

    init() {
        if (!this.header) {
            console.error("2. Error: Header with class '.fixed-header' NOT found. Check your Elementor CSS Class field.");
            return;
        }

        console.log('2. Success: Header element found.');
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('load', this.handleScroll, { passive: true });
        window.addEventListener('pageshow', this.handleScroll, { passive: true });
        requestAnimationFrame(this.handleScroll);
        requestAnimationFrame(() => requestAnimationFrame(this.handleScroll));
        window.setTimeout(this.handleScroll, 150);
    }

    handleScroll = () => {
        if (window.scrollY > this.scrollThreshold) {
            if (!this.header.classList.contains('scrolled')) {
                this.header.classList.add('scrolled');
            }
            return;
        }

        if (this.header.classList.contains('scrolled')) {
            this.header.classList.remove('scrolled');
        }
    };
}
